import { SecurityType } from '@orbis-systems/orbis-api-middleware';

import { parseBondSymbol } from '../stringUtils';

export interface TradeFlagsForSecurityType {
    symbol: string;
    isOption?: boolean;
    isBond?: boolean;
}

export const resolveSecurityTypeFromTradeFlags = ({
    symbol,
    isOption,
    isBond,
}: TradeFlagsForSecurityType): SecurityType => {
    if (isOption) return SecurityType.Option;
    if (isBond || parseBondSymbol(symbol)) return SecurityType.Bond;
    return SecurityType.Equity;
};
